import { channel } from "redux-saga";
import { notificationActions } from "../state/notification/notificationActions";
import { NotificationTypes } from "../state/notification/notificationActionTypes";
import { fork, put, take } from "redux-saga/effects";

const notificationChannel = channel();

function* watchNotificationChannel() {
    while (true) {
        const action = yield take(notificationChannel);
        yield put(action);
    }
}

export default function* appsSaga() {
    yield fork(watchNotificationChannel);
}
